class MCBFeatureChart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.accordionToggles = this.querySelectorAll('.feature-chart__accordion-toggle');

    this.accordionToggles.forEach(toggle => {
      toggle.addEventListener('click', this.toggleAccordion.bind(this));
    });
  }

  toggleAccordion(event) {
    const toggle = event.currentTarget;
    const accordionHeader = toggle.closest('.feature-chart__accordion-header');
    const accordion = accordionHeader.closest('.feature-chart__accordion');
    const content = accordion.querySelector('.feature-chart__accordion-content');

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    toggle.setAttribute('aria-expanded', !isExpanded);

    if (isExpanded) {
      this.hideContent(content);
    } else {
      this.showContent(content);
    }
  }

  showContent(content) {
    content.hidden = false;
    content.style.height = '0';
    content.classList.remove('feature-chart__accordion-content--hidden');
    
    requestAnimationFrame(() => {
      content.style.height = content.scrollHeight + 'px';
      content.classList.add('feature-chart__accordion-content--visible');
    });
  }

  hideContent(content) {
    content.style.height = content.scrollHeight + 'px';
    
    requestAnimationFrame(() => {
      content.style.height = '0';
      content.classList.remove('feature-chart__accordion-content--visible');
      content.classList.add('feature-chart__accordion-content--hidden');
    });
    
    content.addEventListener('transitionend', function handler() {
      if (content.style.height === '0px') {
        content.hidden = true;
        content.style.height = '';
        content.removeEventListener('transitionend', handler);
      }
    });
  }
}

if (!window.customElements.get('mcb-feature-chart')) {
  window.customElements.define('mcb-feature-chart', MCBFeatureChart);
}